import { render, staticRenderFns } from "./loading_base.vue?vue&type=template&id=e18f10e4&scoped=true&"
import script from "./loading_base.vue?vue&type=script&lang=js&"
export * from "./loading_base.vue?vue&type=script&lang=js&"
import style0 from "./loading_base.vue?vue&type=style&index=0&id=e18f10e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18f10e4",
  null
  
)

export default component.exports